import React, { useState, useRef, useCallback } from 'react';
import { Modal } from 'react-bootstrap';
import speakers from '../data/speakers.json';
import * as htmlToImage from 'html-to-image';

const Speakers = () => {
  const [showModal, setShowModal] = useState(false);
  const [selectedSpeakerIndex, setSelectedSpeakerIndex] = useState(0);

  const handleShow = ( index) => {
    setSelectedSpeakerIndex(index);
    setShowModal(true);
  };

  const handleClose = () => setShowModal(false);

  const handleNext = () => {
    setSelectedSpeakerIndex((prevIndex) => 
      prevIndex === speakers.length - 1 ? 0 : prevIndex + 1
    );
  };

  const handlePrevious = () => {
    setSelectedSpeakerIndex((prevIndex) => 
      prevIndex === 0 ? speakers.length - 1 : prevIndex - 1
    );
  };

  const selectedSpeaker = speakers[selectedSpeakerIndex];

  const domEl = useRef(null);

  // const downloadImage = useCallback(async () => {
  //   if (domEl.current) {
  //     try {
  //       // 2. Convert the DOM element to a data URL (PNG format)
  //       const dataUrl = await htmlToImage.toPng(domEl.current);

  //       // 3. Create a temporary anchor link for downloading
  //       const link = document.createElement('a');
  //       link.download = 'downloaded-image.png'; // Set the download file name
  //       link.href = dataUrl;

  //       // 4. Programmatically click the link to trigger the download
  //       link.click();
  //     } catch (err) {
  //       console.error('oops, something went wrong!', err);
  //     }
  //   }
  // }, []);

  const downloadImage = useCallback(async () => {
      // console.log('cardRefs.current:', cardRefs.current);
      // const cardNode = domEl.current[index];
      // console.log('cardNode at index ' + index + ':', cardNode);

      if (domEl.current) {
          try {
              // 2. Convert the DOM element to a data URL (PNG format)
              // const dataUrl = await htmlToImage.toPng(cardNode);
              const dataUrl = await htmlToImage.toPng(domEl.current, {
                  quality: 0.95,
                  pixelRatio: 3,
                  useCORS: false, // Disable CORS
                  allowTaint: true, // Allow tainted canvas
                  ignoreElements: (element) => {
                      // Ignore problematic elements
                      return element.tagName === 'SCRIPT' || element.tagName === 'LINK';
                  }
              });
              // 3. Create a temporary anchor link for downloading
              const link = document.createElement('a');
              link.download = 'plenary-speaker.png'; // Set the download file name
              link.href = dataUrl;

              // 4. Programmatically click the link to trigger the download
              link.click();
          } catch (err) {
              console.error('oops, something went wrong!', err);
          }
      }
  }, []);


  return (
    <section id="speakers" className="speakers-section">
      <div className="container">
        <div className="section-header fade-in">
          <h2 className="display-4 fw-bold">
            <i className="fas fa-users me-3"></i>Speakers
          </h2>
          {/* <p className="lead">Meet our distinguished panel of experts</p> */}
        </div>
        {/* <div className="inline-block bg-gradient-to-r from-cyan-500/10 to-emerald-500/10 p-px rounded-2xl">
          <div className="bg-slate-900/80 backdrop-blur-sm px-8 py-4 rounded-2xl">
            <p className="text-cyan-300/80 font-light tracking-wide text-sm">
              AI CONFERENCE SCHEDULE • OPTIMIZED FOR A4 PRINTING
            </p>
            <button onClick={downloadImage} style={{ marginTop: '10px' }}>
                Download as PNG
            </button>

          </div>
        </div> */}

        {/* {speakers.filter(speaker => speaker.isChiefGuest).map((chiefGuest, index) => ( */}
          {/* <div className="speaker-card text-center mb-4">
            <h3 className="text-primary mb-4">
              Chief Guest
            </h3>
            <div className="speaker-img-container">
              <img src="/img/speakers/vineet-joshi.webp" 
                alt="Sh. Vineet Joshi, IAS"
                className="img-fluid rounded-circle speaker-img"
              />
            </div>
            <div className="speaker-info mt-3">
              <h3 className="h5 fw-bold">Sh. Vineet Joshi, IAS</h3>
              <p className="mb-0">Secretary, Ministry of Education, Government of India</p>
            </div>
          </div> */}
        {/* ))} */}

        <div ref={domEl} className="row g-2">
          {speakers.map((speaker, index) => (
            <div className="col-lg-3 col-md-6" key={index}>
              <div 
                className="speaker-card h-100 fade-in" 
                onClick={() => handleShow(index)}
                style={{ cursor: 'pointer' }}
              >
                <div className="speaker-img-container">
                  <img 
                    src={speaker.photo} 
                    alt={speaker.name} 
                    className="img-fluid rounded-circle speaker-img"
                    onError={(e) => {
                      e.target.onerror = null; 
                      e.target.src = 'https://via.placeholder.com/200x200?text=Speaker+Image';
                    }}
                  />
                </div>

                {speaker.role ? (
                  <p className="guest px-2 text-white fw-bold mb-0">{speaker.role}</p>
                ) : ( <div className="pb-2"></div>
                )}

                <div className="speaker-info">
                  <h3 className="h5 fw-bold mb-1">{speaker.name}</h3>
                  {speaker.designations && speaker.designations.map((designation, index) => (
                    <div key={index} className="">
                      <p className="desig mb-0">
                      {designation.designation}
                      </p>
                      <p className="insti mb-0">
                      {designation.department}
                      </p>
                      <p className="insti mb-0">
                      {designation.institution}
                      </p>
                    </div>
                  ))}
                  <p className="mb-0">{speaker.designation}</p>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Speaker Modal */}
        <Modal show={showModal} onHide={handleClose} centered size='lg'>
          <Modal.Header closeButton>
            <Modal.Title>Speakers - National Symposium on AI</Modal.Title>
          </Modal.Header>
          <div className="cred text-center">
            <div className="row align-items-center mx-0">
              <div className="col-lg-4 px-0">
                <div
                  className="speaker-img-container"
                  // style={{ width: '150px', height: '150px', objectFit: 'cover' }}
                >
                  <img 
                      src={selectedSpeaker?.photo} 
                      alt={selectedSpeaker?.name} 
                      className="img-fluid rounded-circle speaker-img"
                      onError={(e) => {
                      e.target.onerror = null; 
                      e.target.src = 'https://via.placeholder.com/150x150?text=Speaker+Image';
                      }}
                  /><br/>
                </div>
                {selectedSpeaker?.role ? (
                <p className="guest px-2 text-white fw-bold mb-0">{selectedSpeaker?.role}</p>
                ) : ( <></>
                )}
              </div>
              <div className="col-lg-8 ps-lg-2 pe-lg-3 text-lg-start">
                <h5 className="h5">{selectedSpeaker?.name}</h5>
                <div className="row align-items-start mx-0">
                  {selectedSpeaker?.designations && selectedSpeaker?.designations.map((designation, index) => (
                      <div key={index} className="col-lg-6 px-0 small">
                        <p className="text-muted my-0 fw-bold">
                        {designation.designation}
                        </p>
                        <p className="text-muted my-0">
                        {designation.department}
                        </p>
                        <p className="text-muted my-0">
                        {designation.institution}
                        </p>
                      </div>
                  ))}
                  </div>
                <p className="text-muted my-0 small">{selectedSpeaker?.designation}</p>
              </div>
            </div>
          </div>
          <Modal.Body className='pt-0'>
            <p className='text-muted small mb-0' style={{textAlign: 'justify'}}>{selectedSpeaker?.description}</p>
          </Modal.Body>
          <Modal.Footer className='py-0'>
            <button 
              className="btn"
              onClick={handlePrevious}
            >
              <i className="fas fa-chevron-left"></i>
            </button>
            
            <span className="text-muted">
              {selectedSpeakerIndex + 1} of {speakers.length}
            </span>
            
            <button 
              className="btn"
              onClick={handleNext}
            >
              <i className="fas fa-chevron-right"></i>
            </button>
            {/* <button className="btn btn-primary" onClick={handleClose}>
              Close
            </button> */}
          </Modal.Footer>
        </Modal>
      </div>
    </section>
  );
};

export default Speakers;